export const headerStyle = () => {
    const _style =
       {
            height: "40px",
            backgroundColor: "#2b88d8",
        };
    return _style;
  };

export const headerStyleGrid = () => {
  return {
    display: "grid",
    gridTemplateColumns: "10fr 1fr 1fr",
    gridTemplateRows: "auto",
    height: "40px",
    color: "white",
    fontSize: "18px",
    backgroundColor: "#a19f9d", //'#2b88d8',
    alignItems: "center",
    justifyContent: "center",
  };
};

export const headerStyleColumn = () => {
  return {
    marginLeft: "20px",
  };
};
